export default __webpack_public_path__ + "static/media/wTop_1_c3.7f6c7f45.jpeg";